import { Errors } from '../objects/errors';

export const SET_ERRORS = 'LOGIN_SET_ERRORS';
export const TOGGLE_FORGOT_PASSWORD = 'LOGIN_TOGGLE_FORGOT_PASSWORD';
export const TOGGLE_FORGOT_PASSWORD_EMAIL_SENT = 'LOGIN_TOGGLE_FORGOT_PASSWORD_EMAIL_SENT';
export const TOGGLE_PASSWORD = 'LOGIN_TOGGLE_PASSWORD';
export const UPDATE_EMAIL = 'LOGIN_UPDATE_EMAIL';
export const UPDATE_PASSWORD = 'LOGIN_UPDATE_PASSWORD';

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface ToggleForgotPasswordAction {
    type: typeof TOGGLE_FORGOT_PASSWORD
}

interface ToggleForgotPasswordEmailSentAction {
    type: typeof TOGGLE_FORGOT_PASSWORD_EMAIL_SENT
}

interface ToggleShowPasswordAction {
    type: typeof TOGGLE_PASSWORD
}

interface UpdateEmailAction {
    type: typeof UPDATE_EMAIL,
    payload: string
}

interface UpdatePasswordAction {
    type: typeof UPDATE_PASSWORD,
    payload: string
}

export type LoginActionTypes =
    SetErrorsAction |
    ToggleForgotPasswordAction |
    ToggleForgotPasswordEmailSentAction |
    ToggleShowPasswordAction |
    UpdateEmailAction |
    UpdatePasswordAction;